import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es.json';
import en from './en.json';
import pt from './pt.json';
import pl from './pl.json';
import sk from './sk.json';
import fr from './fr.json';
import it from './it.json';
import { TranslationsCacheService } from '../../services/system.services';

// Fallback resources (local JSON files)
const fallbackResources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  pl: { translation: pl },
  sk: { translation: sk },
  fr: { translation: fr },
  it: { translation: it },
};

// Locale code mapping to match database shortcodes
const localeCodeMap = {
  en: 'en',
  es: 'es',
  pt: 'pt',
  pl: 'pl',
  sk: 'sk',
  fr: 'fr',
  it: 'it',
};

// Custom i18next backend to fetch translations from blob storage
class BlobStorageBackend {
  constructor(services, options = {}) {
    this.services = services;
    this.options = options;
    this.type = 'backend';
  }

  async read(language, namespace, callback) {
    try {
      const apiLanguage = localeCodeMap[language] || language;
      const translations = await TranslationsCacheService(apiLanguage);
      callback(null, translations);
    } catch (error) {
      console.error('Error loading translations from backend:', error);
      // Fallback: use local JSON on error
      callback(null, fallbackResources[language]?.translation || {});
    }
  }

  create(languages, namespace, key, fallbackValue) {
    // Placeholder for future implementation
  }
}

const savedLang = sessionStorage.getItem('languageCode') || 'en';
// Instantiate the backend
const blobStorageBackend = new BlobStorageBackend();

i18n
  .use(blobStorageBackend) // Register the backend as a plugin
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackResources, // Always have fallback resources
    fallbackLng: 'en',
    lng: savedLang,
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false, // Prevent suspense issues during async loading
    },
  });

export default i18n;
